// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"576":"a0283d14","849":"27b5cda5","966":"8ab88fd1"}[chunkId] + ".chunk.css";
};